<template>
  <!-- Botón -->
  <a-tooltip
    placement="top"
  >
    <template #title v-if="strategy?.turned_on">
      Para editar la velocidad de marcado, primero debes pausar la estrategia.
    </template>
    <a-button class="table-cell__actions-btn" type="text" @click="openModal" :disabled="strategy?.turned_on">
      <template #icon>
        <DashboardOutlined 
          :style="{
            fontSize: '16px',
          }"
        />
      </template>
      <p>Editar velocidad de marcado</p>
    </a-button>
  </a-tooltip>
  <!-- Modal principal -->
  <a-modal
    v-model:visible="visible"
    width="592px"
    centered
    :keyboard="false"
    :maskClosable="false"
    :footer="null"
  >
    <template #title>
      Edita el ritmo de marcado - {{ strategyName }}
    </template>

    <div class="modal-content">
      <p class="description">
        Controla la velocidad de discado (llamada) para esta estrategia.
      </p>

      <a-radio-group
        v-model:value="selectedSpeed"
        class="options"
      >
        <a-radio :value="StrategySpeed.Low">{{ StrategySpeedText[StrategySpeed.Low] }}</a-radio>
        <a-radio :value="StrategySpeed.Medium">{{ StrategySpeedText[StrategySpeed.Medium] }}</a-radio>
        <a-radio :value="StrategySpeed.High">{{ StrategySpeedText[StrategySpeed.High] }}</a-radio>
      </a-radio-group>

      <a-alert
        :message="alertMessage"
        type="warning"
        show-icon
      />
    </div>

    <div class="footer">
      <a-button @click="handleDiscard">Cancelar</a-button>
      <a-button
        type="primary"
        :loading="loading"
        :disabled="!hasChanges"
        @click="handleSave"
      >
        Guardar cambios
      </a-button>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { DashboardOutlined } from "@ant-design/icons-vue";
import { message, Modal } from "ant-design-vue";
import { useStore } from "vuex";
import { StrategySpeed, StrategySpeedDescription, StrategySpeedText } from "../../utils/modalStrategy";
import { assignDataToStrategy } from "../../services/agents/assignDataToStrategy";


const props = defineProps({
  strategyName: {
    type: String,
  },
  strategy: {
    type: Object,
  },
});

const visible = ref(false);
const originalSpeed = ref(props.strategy?.intensity_level || 3); // valor inicial
const selectedSpeed = ref(props.strategy?.intensity_level || 3);
const loading = ref(false);
const store = useStore();

// watch(
//   () => props.strategy,
//   (newValue: any) => {
//     originalSpeed.value = newValue?.intensity_level || 3;
//     selectedSpeed.value = newValue?.intensity_level || 3;
//   }
// );

const openModal = () => {
  selectedSpeed.value = originalSpeed.value;
  visible.value = true;
};

const hasChanges = computed(() => selectedSpeed.value !== originalSpeed.value);

const alertMessage = computed(() => {
  return StrategySpeedDescription[selectedSpeed.value as StrategySpeed] || "";
});

// Confirmar guardado
const handleSave = () => {
  Modal.confirm({
    title: "¿Estás seguro de guardar los cambios?",
    content: "Se guardarán los cambios al ritmo de llamada de la estrategia.",
    okText: "Si, guardar cambios",
    cancelText: "No, seguir editando",
    centered: true,
    onOk: async () => {
      loading.value = true;

      try {
        await assignDataToStrategy(props?.strategy?.id, "assignSpeed", {
          intensity_level: selectedSpeed.value
        });
        store.dispatch("fetchAllStrategies");
        message.success("Cambios guardados con éxito.");
      } catch {
        message.error("Hubo un error al guardar los cambios");
      }
      originalSpeed.value = selectedSpeed.value;
      visible.value = false;
      loading.value = false;
    },
  });
};

// Confirmar descarte
const handleDiscard = () => {
  if (!hasChanges.value) {
    visible.value = false;
    return;
  }

  Modal.confirm({
    title: "¿Deseas descartar los cambios realizados?",
    content:
      "Recuerda que, si no guardas los cambios que realizaste, estos serán descartados.",
    okText: "Sí, descartar",
    cancelText: "No, seguir editando",
    centered: true,
    onOk: () => {
      selectedSpeed.value = originalSpeed.value;
      visible.value = false;
    },
  });
};
</script>

<style lang="sass" scoped>
.edit-btn
  display: flex
  align-items: center
  gap: 8px
  font-size: 14px
  color: #999
  cursor: pointer
  background: none
  border: none
  padding: 4px 0

  &:hover
    color: #1677ff

.icon
  font-size: 16px

.description
  color: #444
  margin-bottom: 16px

.options
  display: flex
  gap: 24px
  margin: 12px 0

.option
  display: flex
  align-items: center
  gap: 6px
  font-size: 14px
  cursor: pointer

  input[type="radio"]
    accent-color: #1677ff
    cursor: pointer

.alert
  display: flex
  align-items: center
  padding: 10px 14px
  border-radius: 6px
  font-size: 13px
  margin-top: 12px
  background: #fff8e6
  border: 1px solid #ffe58f
  color: #ad8b00

.footer
  display: flex
  justify-content: flex-end
  gap: 10px
  margin-top: 20px

.modal-content
  padding: 20px 40px
</style>
